import React from 'react';
import { FileSignature } from 'lucide-react';
import { useProrataConfig } from './prorataAvenant';

const dateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');
const MODES = { mois: 'mois restants ÷ 12', pourcentage: 'pourcentage personnalisé', jours: 'jours personnalisés ÷ 365', desactive: 'prorata désactivé' };

// Rappel « Avenant au contrat … du … au … » + prorata (personnalisable super admin)
export default function BandeauAvenant({ contratParent, resultat, isSuperAdmin }) {
  const [config, setConfig] = useProrataConfig();
  if (!contratParent) return null;
  const ref = contratParent.numero_police || contratParent.ref_solidaire || contratParent.id;
  const fin = contratParent.date_fin || contratParent.periode_adhesion_fin;
  const p = resultat?.prorata;
  return (
    <div className="mb-4 rounded-xl border-2 border-purple-200 bg-purple-50 p-4" data-testid="bandeau-avenant">
      <p className="flex items-center gap-2 text-sm font-semibold text-purple-900">
        <FileSignature className="h-4 w-4" /> Avenant au contrat <span className="font-mono" data-testid="bandeau-avenant-ref">{ref}</span>
      </p>
      <p className="mt-1 text-sm text-purple-800" data-testid="bandeau-avenant-periode">
        du <strong>{dateFr(new Date())}</strong> au <strong>{dateFr(fin)}</strong> (date de fin du contrat parent)
      </p>
      {p && (
        <p className="mt-1 text-xs text-purple-700" data-testid="bandeau-avenant-prorata">
          Prorata appliqué : <strong>{(p.facteur * 100).toFixed(2).replace('.', ',')} %</strong> — {MODES[p.mode]}
          {p.mode === 'mois' && ` (${p.mois} mois sur 12)`}
        </p>
      )}
      {isSuperAdmin && (
        <div className="mt-3 flex flex-wrap items-center gap-3 border-t border-purple-200 pt-3 text-xs text-purple-900" data-testid="prorata-perso">
          <label className="flex items-center gap-1.5">
            <input type="checkbox" checked={!!config.desactive} onChange={(e) => setConfig({ desactive: e.target.checked })}
              className="h-4 w-4 accent-purple-600" data-testid="prorata-desactiver" /> Désactiver le prorata
          </label>
          <label className="flex items-center gap-1.5">% appliqué
            <input type="number" min="0" max="100" step="0.01" value={config.pourcentage} disabled={config.desactive}
              onChange={(e) => setConfig({ pourcentage: e.target.value })} placeholder="auto"
              className="w-20 rounded border border-purple-300 px-2 py-1" data-testid="prorata-pourcentage" />
          </label>
          <label className="flex items-center gap-1.5">ou nombre de jours
            <input type="number" min="1" max="365" value={config.jours} disabled={config.desactive || !!config.pourcentage}
              onChange={(e) => setConfig({ jours: e.target.value })} placeholder="auto"
              className="w-20 rounded border border-purple-300 px-2 py-1" data-testid="prorata-jours" />
          </label>
        </div>
      )}
    </div>
  );
}
